export default "__VITE_ASSET__m$oPhMfH__"